<div class="charging-stations-page" data-testid="charging-stations-container">
  <app-modal-option-panel>
    <h3 panel-title>{{ panelTitle }}</h3>

    @if (stations().length > 0) {
      <div class="cs-list" data-testid="charging-stations-list">
        @for (charger of stations(); track charger.id) {
          <div class="cs-card" [attr.data-testid]="'charging-stations-item-' + charger.id">
            <img class="cs-card__icon" [attr.data-testid]="'charging-stations-icon-btn-' + charger.id" [src]="getStationIcon(charger)" alt="charging station" (click)="openStation(charger)" (keydown.enter)="openStation(charger)" />
            <button type="button" class="cs-card__text ev-plain-button" [attr.data-testid]="'charging-stations-info-btn-' + charger.id" (click)="openStation(charger)">
              <span class="cs-card__title">{{ charger.title }}</span>
              <span class="cs-card__operator">{{ getOperatorName(charger) }}</span>
            </button>
            <button class="cs-card__remove" type="button" [attr.data-testid]="'charging-stations-remove-btn-' + charger.id" (click)="removeStation(charger)"
              [attr.aria-label]="languageService.languageJSON?.Global_Unmark_All">
              <img [src]="'assets/icons/dark/ui/deletetrack_icon_white.svg'" alt="delete" />
            </button>
          </div>
        }
      </div>
    } @else if (!isLoading()) {
      <p class="cs-empty">{{ languageService.languageJSON?.Global_NoData }}</p>
    }
  </app-modal-option-panel>

  @if (stations().length > 0) {
    <div class="cs-actions">
      <button class="ev-pill-button" type="button" data-testid="charging-stations-remove-all-btn" (click)="removeAll()">
        {{ mode === 'favorite'
          ? languageService.languageJSON?.Global_Unmark_All
          : languageService.languageJSON?.Global_ReEnable_All }}
      </button>
    </div>
  }

  @if (isLoading()) {
    <div class="cs-loader">
      <app-ev-loader></app-ev-loader>
    </div>
  }
</div>
